<script lang="ts" setup>
defineProps<{
  id: number
  title: string
  summary: string
  cover: string
  tags?: string[]
  likes: number
  views: number
  comments: number
  userId: number
  username: string
  userAvatar: string
  badges: number[]
  userAuth?: User.Auth
  createdAt: number
}>()
</script>

<template>
  <div class="m-article-card">
    <div class="m-article-card__header">
      <m-user-info
        :id="userId"
        :name="username"
        :avatar="userAvatar"
        :badges="badges"
        :auth="userAuth"
        size="xs"
      >
        <div>{{ pipe.date(createdAt) }}</div>
      </m-user-info>
    </div>
    <m-link :resource-id="id" :resource-type="0" :title="title">
      <div class="m-article-card__title">
        <h3 class="m-article-card__h3">{{ title }}</h3>
      </div>
      <div class="m-article-card__content">{{ summary }}</div>
      <div class="m-article-card__cover">
        <m-img :src="cover" alt="m-article-card__cover" />
      </div>
    </m-link>
    <div class="m-article-card__footer">
      <div class="m-article-card__tags">
        <m-topics :topics="tags" />
      </div>
      <div class="m-article-card__data">
        <div class="m-article-card__data-item">
          <span>{{ pipe.num(views) }}阅读</span>
        </div>
        <div class="m-article-card__data-item">
          <span>{{ pipe.num(comments) }}评论</span>
        </div>
        <div class="m-article-card__data-item">
          <span>{{ pipe.num(likes) }}赞</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-article-card {
  &__header {
    margin-bottom: 16px;
  }

  &__title {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    padding-right: 100px;
  }

  &__h3 {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  &__content {
    line-height: 18px;
    margin-top: 8px;
    color: var(--color-gray-600);
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  &__cover {
    margin-top: 10px;
    width: 208px;
    height: 115px;
  }

  &__data {
    margin-top: 5px;
    display: flex;
    align-items: center;

    &-item {
      margin-right: 10px;
      display: flex;
      align-items: center;

      > span {
        padding-right: 8px;
        font-size: 12px;
        color: var(--color-gray-500);
      }
    }
  }
}
</style>
